import React, { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useLogoLayout } from '../contexts/LogoLayoutContext';

/**
 * RouteTransitionLogo is a "slot" placeholder. It reserves space inside the
 * page layout where the Allure logo should appear, but the actual logo image
 * is rendered globally by <FloatingLogo /> mounted at the App root. Each
 * slot registers itself with its mount-time pathname so the global logo can
 * fade out instantly when navigating to a slot-less route (e.g., chat).
 */
export const RouteTransitionLogo = ({
  width,
  height,
  dataTestId = 'route-transition-logo',
  className = '',
  style = {},
}) => {
  const ref = useRef(null);
  const { registerSlot, unregisterSlot } = useLogoLayout();
  const location = useLocation();

  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    registerSlot(node, location.pathname);
    return () => unregisterSlot(node);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={ref}
      data-testid={dataTestId}
      data-logo-slot="true"
      className={className}
      aria-hidden="true"
      style={{
        width,
        height,
        display: 'block',
        visibility: 'hidden',
        ...style,
      }}
    />
  );
};

export default RouteTransitionLogo;
